import { Directive, Input, HostListener, HostBinding } from '@angular/core';
import { ErrorTypeManagerService } from '../services/ErrorTypeManagerService';
import { JobErrorModel } from '../models/JobErrorModel';

@Directive({
  selector: '[brdErrorType]'
})
export class ErrorTypeDirective {

  @Input('brdErrorType')
  error: JobErrorModel;

  @HostListener('click')
  onClick() {
    this.errorTypeManagerService.handleType(this.error);
  }

  @HostBinding('style.color')
  public get color(): string {
    if (this.error) {
      return this.errorTypeManagerService.canHandleType(this.error) ? "blue" : "";
    }
    return "";
  }

  @HostBinding('style.text-decoration')
  public get textDecoration(): string {
    if (this.error) {
      return this.errorTypeManagerService.canHandleType(this.error) ? "underline" : "";
    }
    return "";
  }
  
constructor(private errorTypeManagerService: ErrorTypeManagerService) { }

}



// WEBPACK FOOTER //
// ./src/app/submission/directives/error-type.directive.ts